import { FrameName } from "../config";
import ForestTerrainTileEntity from "./ForestTerrainTileEntity";

class DenseForestTerrainTileEntity extends ForestTerrainTileEntity {
	public static readonly frameName = FrameName.DENSE_FOREST;
}

export default DenseForestTerrainTileEntity;
